import { apiAxiosCMS } from 'services/api';
import { LogoProps } from 'types/LogoProps';

interface RespReqProps {
	isSuccess: boolean;
	list: LogoProps[];
}

export async function getLogos(
	setIsOpenLoad: React.Dispatch<React.SetStateAction<boolean>>,
	handleNotify: any
) {
	const respReq: RespReqProps = {
		isSuccess: false,
		list: []
	};

	setIsOpenLoad(true);
	await apiAxiosCMS
		.get('logo')
		.then((res) => {
			respReq.isSuccess = true;
			respReq.list = res?.data || [];
		})
		.catch((error) => {
			console.error('✌️error --->', error);
			respReq.isSuccess = false;
			respReq.list = [];
			handleNotify('Erro ao buscar a lista de logos.', 'error');
		});

	setIsOpenLoad(false);
	return respReq;
}

export async function deleteLogoReq(id: string, handleNotify: any) {
	const respReq = {
		isSuccess: false
	};
	await apiAxiosCMS
		.delete(`logo/${id}`)
		.then(() => {
			handleNotify('Logo deletada com sucesso', 'success');
			respReq.isSuccess = true;
		})
		.catch((error) => {
			console.error('✌️error --->', error);
			handleNotify('Erro ao deletar logo, tente novamente.', 'error');
			respReq.isSuccess = false;
		});

	return respReq;
}
